import React, { Component } from "react";
import { Label, FormGroup, Modal, Alert } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { errorMessage } from "../../helpers/ApiHelper";

const emptyAdmin = () => ({
  name: "",
  surname: "",
  email: "",
  password: "",
  passwordConfirm: "",
});

class AddAdmin extends Component {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = { newAdmin: emptyAdmin(), validationError: "" };
  }

  componentDidUpdate(prevProps) {
    // The reducer closes the modal only on a successful save — reset for the next open.
    if (prevProps.isNewAdminModalOpen && !this.props.isNewAdminModalOpen) {
      this.setState({ newAdmin: emptyAdmin(), validationError: "" });
    }
  }

  onCancel() {
    this.setState({ newAdmin: emptyAdmin(), validationError: "" });
    this.props.onCancel();
  }

  validate(newAdmin) {
    if (
      !newAdmin.name ||
      !newAdmin.surname ||
      !newAdmin.email ||
      !newAdmin.password ||
      !newAdmin.passwordConfirm
    ) {
      return "Моля, попълнете всички полета";
    }
    if (newAdmin.password.length < 8) {
      return "Паролата трябва да е поне 8 символа";
    }
    if (newAdmin.password !== newAdmin.passwordConfirm) {
      return "Паролите не съвпадат";
    }
    return "";
  }

  onSubmit(e) {
    e.preventDefault();
    const { newAdmin } = this.state;
    const validationError = this.validate(newAdmin);
    this.setState({ validationError });
    if (validationError) {
      return;
    }
    this.props.onSubmit(newAdmin);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState((state) => ({
      newAdmin: { ...state.newAdmin, [name]: value },
    }));
  }

  render() {
    const { newAdmin, validationError } = this.state;
    const submitError = this.props.error ? errorMessage(this.props.error) : "";
    const shownError = validationError || submitError;
    return (
      <Modal isOpen={this.props.isNewAdminModalOpen} toggle={this.onCancel}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Добави администратор</h5>
          <button
            type="button"
            onClick={this.onCancel}
            className="close"
            data-dismiss="modal"
            aria-label="Затвори"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {shownError && <Alert color="danger">{shownError}</Alert>}
          <AvForm className="needs-validation">
            <FormGroup>
              <Label htmlFor="validationCustom01">Име </Label>
              <AvField
                name="name"
                placeholder="Име"
                type="text"
                errorMessage="Моля, въведете име"
                className="form-control"
                onChange={this.handleChange}
                value={newAdmin.name}
                validate={{ required: { value: true } }}
                id="validationCustom01"
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="validationCustom02">Фамилия</Label>
              <AvField
                name="surname"
                placeholder="Фамилия"
                type="text"
                errorMessage="Моля, въведете фамилия"
                className="form-control"
                onChange={this.handleChange}
                value={newAdmin.surname}
                validate={{ required: { value: true } }}
                id="validationCustom02"
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="validationCustom03">Имейл</Label>
              <AvField
                name="email"
                placeholder="Имейл"
                type="email"
                errorMessage="Моля, въведете имейл"
                className="form-control"
                onChange={this.handleChange}
                value={newAdmin.email}
                validate={{ required: { value: true } }}
                id="validationCustom03"
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="validationCustom04">Парола</Label>
              <AvField
                name="password"
                placeholder="Парола"
                type="password"
                errorMessage="Моля, въведете парола"
                className="form-control"
                onChange={this.handleChange}
                value={newAdmin.password}
                validate={{ required: { value: true }, minLength: { value: 8 } }}
                id="validationCustom04"
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="validationCustom05">Потвърди парола</Label>
              <AvField
                name="passwordConfirm"
                placeholder="Потвърди парола"
                type="password"
                errorMessage="Моля, потвърдете паролата коректно"
                className="form-control"
                onChange={this.handleChange}
                value={newAdmin.passwordConfirm}
                validate={{ required: { value: true } }}
                id="validationCustom05"
              />
            </FormGroup>
          </AvForm>
        </div>

        {this.props.isLoading && (
          <div className="modal-footer">
            <div className="spinner-border text-success m-1" role="status">
              <span className="sr-only">Зареждане…</span>
            </div>
          </div>
        )}

        {!this.props.isLoading && (
          <div className="modal-footer">
            <button
              type="button"
              onClick={this.onCancel}
              className="btn btn-secondary waves-effect"
              data-dismiss="modal"
            >
              Отказ
            </button>
            <button
              type="button"
              onClick={this.onSubmit}
              className="btn btn-success waves-effect waves-light"
            >
              Добави
            </button>
          </div>
        )}
      </Modal>
    );
  }
}

export default AddAdmin;
